import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { Swiper, SwiperSlide } from 'swiper/react'

import * as SvgIcons from 'assets/svg/sprite'

import 'swiper/css'
import './_categoriesSlider.scss'

interface Props {
    categories: Array<{
        name: string
        id: string
        premium: number
        posts: number
        messages: number
        stories: number
        public: boolean | number
    }>
    categoriesOpen: boolean
    selectedCategory: string
    setSelectedCategory: any
    initialCategorySlide: number
    setInitialCategorySlide: any
    ownProfile: boolean
}

const CategoriesSlider = ({
    categories,
    categoriesOpen,
    selectedCategory,
    setSelectedCategory,
    initialCategorySlide,
    setInitialCategorySlide,
    ownProfile,
}: Props) => {
    const { t } = useTranslation()

    const isPublic = (v: any) => v === true || v === 1 || v === '1'

    const filteredCategories =
    categories?.filter(category => {
        return isPublic(category.public)
    }) ?? []

    return (
        <div
            className={`categories ${
                categoriesOpen ? 'categories-slider-open' : ''
            }`}
        >
            {filteredCategories.length !== 0 ? (
                <div className='categories__list'>
                    <Swiper
                        spaceBetween={5}
                        slidesPerView='auto'
                        initialSlide={initialCategorySlide}
                    >
                        {filteredCategories.map(category => (
                            <SwiperSlide
                                key={category.id}
                                style={{ width: 'auto' }}
                            >
                                <div
                                    className={`category ${
                                        selectedCategory === category.id
                                            ? 'active'
                                            : ''
                                    }`}
                                    onClick={() => {
                                        if (selectedCategory === category.id) {
                                            setSelectedCategory('')
                                            setInitialCategorySlide(0)
                                        } else {
                                            setInitialCategorySlide(
                                                categories.indexOf(category)
                                            )
                                            setSelectedCategory(category.id)
                                        }
                                    }}
                                >
                                    #{category.name.toLowerCase()}
                                </div>
                            </SwiperSlide>
                        ))}

                        {/* Add button at the end of the row when categories exist (creator only) */}
                        {ownProfile && (
                            <SwiperSlide
                                key='add-category'
                                style={{ width: 'auto' }}
                            >
<Link
    to={{ pathname: '/media_categories' }}
    className='categories__addBtn'
    onClick={e => e.stopPropagation()}
    aria-label='Add category'
    title='Add category'
>
    <SvgIcons.IconAddCategorie />
</Link>
                            </SwiperSlide>
                        )}
                    </Swiper>
                </div>
            ) : ownProfile ? (
                <Link
                    className='noCategories'
                    to={{ pathname: '/media_categories' }}
                >
                    <p>{t('noCategories')}</p>
                    <SvgIcons.IconAddCategorie />
                </Link>
            ) : (
                <div className='noCategories'>
                    <p>{t('noCategories')}</p>
                </div>
            )}
        </div>
    )
}

export default CategoriesSlider
